module.exports = "pegasus/assets/arc-logo.png";